import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState } from 'react';
import ChannelListHeader from './ChannelListHeader.js';
import { AddChannel } from './AddChannel.js';
import ChannelPreview from './ChannelPreview.js';
import ChannelPreviewAction from './ChannelPreviewAction.js';
import { u as useChannelListContext, F as FETCH_CHANNELS_START, a as FETCH_CHANNELS_SUCCESS, b as FETCH_CHANNELS_FAILURE, L as LEAVE_CHANNEL_SUCCESS, S as SET_CURRENT_CHANNEL } from '../../ChannelListProvider-e9a09891.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import EditProfile from '../../EditUserProfile.js';
import { P as PlaceHolder, a as PlaceHolderTypes } from '../../index-2cfab646.js';
import '../../LocalizationContext-a82461b5.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import '../../index-6420013c.js';
import 'prop-types';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../ui/Icon.js';
import '../../uuid-717930b4.js';
import '../../ui/IconButton.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../CreateChannel.js';
import '../../CreateChannel/components/CreateChannelUI.js';
import '../../CreateChannelProvider-47a1c523.js';
import '../../sendbirdSelectors.js';
import '../../topics-eb548880.js';
import '../../utils-e0c7329c.js';
import '../../CreateChannel/components/InviteUsers.js';
import '../../ui/Modal.js';
import 'react-dom';
import '../../index-a9101009.js';
import '../../ui/Button.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/UserListItem.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../ui/ContextMenu.js';
import '../../ui/SortByRow.js';
import '../../index-579ca9d7.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../CreateChannel/components/SelectChannelType.js';
import '../../ui/ChannelAvatar.js';
import '../../utils-7f5e872b.js';
import '../../ui/Badge.js';
import '../../index-ac0b2d20.js';
import '../../index-ccef08fe.js';
import '../../ui/Loader.js';
import '../../index-f879f6ef.js';
import '../../index-ad50e2c0.js';
import '../../ui/MentionUserLabel.js';
import '../../consts-b4cb83cf.js';
import '../../ui/TextButton.js';
import '../../color-91e43dce.js';
import '../../Channel/components/TypingIndicator.js';
import '@sendbird/chat/groupChannel';
import '../../ChannelProvider-5dcbee7b.js';
import '../../const-72f012b6.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../useLongPress-12280c78.js';
import '../../withSendbird.js';
import '../../index-10dad19d.js';
import '../../ui/Input.js';
import '../../actionTypes-ba87a2c9.js';
var isAboutSame = function isAboutSame(a, b, px) {
  return Math.abs(a - b) <= px;
};
var DELIVERY_RECIPT = 'delivery_receipt';
var ChannelListUI = function ChannelListUI(props) {
  var _state$stores;
  var renderHeader = props.renderHeader,
    renderChannelPreview = props.renderChannelPreview,
    renderPlaceHolderError = props.renderPlaceHolderError,
    renderPlaceHolderLoading = props.renderPlaceHolderLoading,
    renderPlaceHolderEmptyList = props.renderPlaceHolderEmptyList;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showProfileEdit = _useState2[0],
    setShowProfileEdit = _useState2[1];
  var _useChannelListContex = useChannelListContext(),
    onThemeChange = _useChannelListContex.onThemeChange,
    allowProfileEdit = _useChannelListContex.allowProfileEdit,
    allChannels = _useChannelListContex.allChannels,
    loading = _useChannelListContex.loading,
    currentChannel = _useChannelListContex.currentChannel,
    channelListDispatcher = _useChannelListContex.channelListDispatcher,
    channelSource = _useChannelListContex.channelSource,
    typingChannels = _useChannelListContex.typingChannels,
    initialized = _useChannelListContex.initialized;
  var state = useSendbirdStateContext();
  var sdkStore = state === null || state === void 0 ? void 0 : (_state$stores = state.stores) === null || _state$stores === void 0 ? void 0 : _state$stores.sdkStore;
  var config = state === null || state === void 0 ? void 0 : state.config;
  var logger = config.logger,
    _config$isOnline = config.isOnline,
    isOnline = _config$isOnline === void 0 ? false : _config$isOnline,
    markAsDeliveredScheduler = config.markAsDeliveredScheduler,
    disableMarkAsDelivered = config.disableMarkAsDelivered;
  var sdk = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.sdk;
  var sdkError = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.error;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-channel-list__header"
  }, (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || /*#__PURE__*/React__default.createElement(ChannelListHeader, {
    onEdit: function onEdit() {
      if (allowProfileEdit) {
        setShowProfileEdit(true);
      }
    },
    allowProfileEdit: allowProfileEdit,
    renderIconButton: function renderIconButton() {
      return /*#__PURE__*/React__default.createElement(AddChannel, null);
    }
  })), showProfileEdit && /*#__PURE__*/React__default.createElement(EditProfile, {
    onThemeChange: onThemeChange,
    onCancel: function onCancel() {
      setShowProfileEdit(false);
    },
    onEditProfile: function onEditProfile() {
      setShowProfileEdit(false);
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-channel-list__body",
    onScroll: function onScroll(e) {
      var target = e === null || e === void 0 ? void 0 : e.target;
      var fetchMore = isAboutSame(target.clientHeight + target.scrollTop, target.scrollHeight, 10);
      if (fetchMore && channelSource !== null && channelSource !== void 0 && channelSource.hasNext) {
        logger.info('ChannelList: Fetching more channels');
        channelListDispatcher({
          type: FETCH_CHANNELS_START,
          payload: null
        });
        channelSource.next().then(function (channelList) {
          var _sdk$appInfo, _sdk$appInfo$premiumF;
          logger.info('ChannelList: Fetching channels successful', channelList);
          channelListDispatcher({
            type: FETCH_CHANNELS_SUCCESS,
            payload: channelList
          });
          var canSetMarkAsDelivered = sdk === null || sdk === void 0 ? void 0 : (_sdk$appInfo = sdk.appInfo) === null || _sdk$appInfo === void 0 ? void 0 : (_sdk$appInfo$premiumF = _sdk$appInfo.premiumFeatureList) === null || _sdk$appInfo$premiumF === void 0 ? void 0 : _sdk$appInfo$premiumF.find(function (feature) {
            return feature === DELIVERY_RECIPT;
          });
          if (canSetMarkAsDelivered && !disableMarkAsDelivered) {
            logger.info('ChannelList: Marking all channels as read');
            // eslint-disable-next-line no-unused-expressions
            channelList === null || channelList === void 0 ? void 0 : channelList.forEach(function (channel) {
              if ((channel === null || channel === void 0 ? void 0 : channel.unreadMessageCount) > 0) {
                markAsDeliveredScheduler.push(channel);
              }
            });
          }
        }).catch(function (err) {
          logger.info('ChannelList: Fetching channels failed', err);
          channelListDispatcher({
            type: FETCH_CHANNELS_FAILURE,
            payload: err
          });
        });
      }
    }
  }, sdkError && !loading && (renderPlaceHolderError && typeof renderPlaceHolderError === 'function' ? renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError() : /*#__PURE__*/React__default.createElement(PlaceHolder, {
    type: PlaceHolderTypes.WRONG
  })), /*#__PURE__*/React__default.createElement("div", null, allChannels && allChannels.map(function (channel, idx) {
    // todo: Refactor and move this inside channel - preview
    var _onLeaveChannel = function onLeaveChannel(c, cb) {
      logger.info('ChannelList: Leaving channel', c);
      c.leave().then(function (res) {
        logger.info('ChannelList: Leaving channel success', res);
        if (cb && typeof cb === 'function') {
          cb(res, null);
        }
        channelListDispatcher({
          type: LEAVE_CHANNEL_SUCCESS,
          payload: channel === null || channel === void 0 ? void 0 : channel.url
        });
      }).catch(function (err) {
        logger.error('ChannelList: Leaving channel failed', err);
        if (cb && typeof cb === 'function') {
          cb(null, err);
        }
      });
    };
    var onClick = function onClick() {
      if (!isOnline) {
        return;
      }
      logger.info('ChannelList: Clicked on channel:', channel);
      channelListDispatcher({
        type: SET_CURRENT_CHANNEL,
        payload: channel
      });
    };
    return renderChannelPreview ? /*#__PURE__*/
    // eslint-disable-next-line
    React__default.createElement("div", {
      key: channel === null || channel === void 0 ? void 0 : channel.url,
      onClick: onClick
    }, renderChannelPreview({
      channel: channel,
      onLeaveChannel: _onLeaveChannel
    })) : /*#__PURE__*/React__default.createElement(ChannelPreview, {
      key: channel === null || channel === void 0 ? void 0 : channel.url,
      tabIndex: idx,
      onClick: onClick,
      channel: channel,
      onLeaveChannel: function onLeaveChannel() {
        return _onLeaveChannel(channel, null);
      },
      isActive: (channel === null || channel === void 0 ? void 0 : channel.url) === (currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url),
      isTyping: typingChannels === null || typingChannels === void 0 ? void 0 : typingChannels.some(function (_ref) {
        var url = _ref.url;
        return url === (channel === null || channel === void 0 ? void 0 : channel.url);
      }),
      renderChannelAction: function renderChannelAction() {
        return /*#__PURE__*/React__default.createElement(ChannelPreviewAction, {
          channel: channel,
          disabled: !isOnline,
          onLeaveChannel: function onLeaveChannel() {
            return _onLeaveChannel(channel, null);
          }
        });
      }
    });
  })), !initialized && loading && (renderPlaceHolderLoading && typeof renderPlaceHolderLoading === 'function' ? renderPlaceHolderLoading === null || renderPlaceHolderLoading === void 0 ? void 0 : renderPlaceHolderLoading() : /*#__PURE__*/React__default.createElement(PlaceHolder, {
    type: PlaceHolderTypes.LOADING
  })), initialized && (allChannels === null || allChannels === void 0 ? void 0 : allChannels.length) === 0 && (renderPlaceHolderEmptyList && typeof renderPlaceHolderEmptyList === 'function' ? renderPlaceHolderEmptyList === null || renderPlaceHolderEmptyList === void 0 ? void 0 : renderPlaceHolderEmptyList() : /*#__PURE__*/React__default.createElement(PlaceHolder, {
    type: PlaceHolderTypes.NO_CHANNELS
  }))));
};
export { ChannelListUI as default };